import { defineMessages } from 'react-intl';

export default defineMessages({
    myOffers: {
        id: '_.navigation.myOffers',
        defaultMessage: 'My Offers'
    },
    iwocapaySeller: {
        id: '_.navigation.iwocapayDashboard',
        defaultMessage: 'iwocaPay Seller'
    },
    flexi12Dashboard: {
        id: '_.navigation.flexi12_dashboard',
        defaultMessage: 'Flexi-Loan'
    },
    flexi24Dashboard: {
        id: '_.navigation.flexi24_dashboard',
        defaultMessage: 'Flexi-24'
    },
    CBILSDashboard: {
        id: '_.navigation.cbils_dashboard',
        defaultMessage: 'CBILS Loan'
    },
    firstCBILS: {
        id: '_.navigation.first_cbils_dashboard',
        defaultMessage: '1st CBILS Loan'
    },
    secondCBILS: {
        id: '_.navigation.second_cbils_dashboard',
        defaultMessage: '2nd CBILS Loan'
    },
    firstCBILSMobile: {
        id: '_.navigation.first_cbils_dashboard_mobile',
        defaultMessage: '1st CBILS'
    },
    secondCBILSMobile: {
        id: '_.navigation.second_cbils_dashboard_mobile',
        defaultMessage: '2nd CBILS'
    },
    tradingData: {
        id: '_.navigation.trading_data',
        defaultMessage: 'Upload Documents'
    },
    contracts: {
        id: '_.navigation.contracts',
        defaultMessage: 'Contracts'
    },
    accountHistory: {
        id: '_.navigation.account_history',
        defaultMessage: 'Transactions'
    },
    personalGuarantees: {
        id: '_.navigation.personal_guarantees',
        defaultMessage: 'Personal Guarantees'
    },
    yourCompany: {
        id: '_.navigation.your_company',
        defaultMessage: 'Profile'
    },
    help: {
        id: '_.nagivation.help',
        defaultMessage: 'Help'
    },
    logout: {
        id: '_.nagivation.logout',
        defaultMessage: 'Logout'
    },
    menu: {
        id: '_.nagivation.menu',
        defaultMessage: 'Menu'
    },
    loanDashboard: {
        id: '_.nagivation.loanDashboard',
        defaultMessage: 'Loan Dashboard'
    },
    account: {
        id: '_.nagivation.account',
        defaultMessage: 'Account'
    },
    termsOfuse: {
        id: '_.navigation.terms_of_use',
        defaultMessage: 'Terms of use'
    }
});
